import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    register_now_login_text: {
      id: 'register_now_login_text',
      defaultMessage: "Register now",
      description: '',
    },
    forgot_password_login_text: {
      id: 'forgot_password_login_text',
      defaultMessage: "Forgot password?",
      description: '',
    },
    back_to_login: {
      id: 'back_to_login',
      defaultMessage: "Back to login page",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/LoginElements/Messages.js